export function triggerEvent(eventName, detail?) {
  window.dispatchEvent(
    new CustomEvent(eventName, {
      detail,
    })
  )
}
